export const FLAGS = {
  alemania: '🇩🇪',
  argentina: '🇦🇷',
  austria: '🇦🇹',
  belgica: '🇧🇪',
  benin: '🇧🇯',
  bosnia_herzegovina: '🇧🇦',
  brasil: '🇧🇷',
  burkina_faso: '🇧🇫',
  camerun: '🇨🇲',
  colombia: '🇨🇴',
  corea_del_sur: '🇰🇷',
  dinamarca: '🇩🇰',
  ecuador: '🇪🇨',
  egipto: '🇪🇬',
  escocia: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  eslovenia: '🇸🇮',
  espana: '🇪🇸',
  francia: '🇫🇷',
  gales: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  ghana: '🇬🇭',
  grecia: '🇬🇷',
  hungria: '🇭🇺',
  inglaterra: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  italia: '🇮🇹',
  japon: '🇯🇵',
  kosovo: '🇽🇰',
  luxemburgo: '🇱🇺',
  mexico: '🇲🇽',
  nigeria: '🇳🇬',
  noruega: '🇳🇴',
  nueva_zelanda: '🇳🇿',
  paises_bajos: '🇳🇱',
  paraguay: '🇵🇾',
  polonia: '🇵🇱',
  portugal: '🇵🇹',
  republica_checa: '🇨🇿',
  republica_dominicana: '🇩🇴',
  senegal: '🇸🇳',
  suecia: '🇸🇪',
  suiza: '🇨🇭',
  uruguay: '🇺🇾',
  usa: '🇺🇸',
  georgia: '🇬🇪',
  rusia: '🇷🇺',
  serbia: '🇷🇸',
  ucrania: '🇺🇦',
  venezuela: '🇻🇪',
  vietnam: '🇻🇳',
  zambia: '🇿🇲',
  croacia: '🇭🇷',
  rumania: '🇷🇴',
  albania: '🇦🇱',
  armenia: '🇦🇲',
  marruecos: '🇲🇦',
  chile: '🇨🇱'
};

export type CountryCode = keyof typeof FLAGS;
